/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var DcmIcon = createIcon("DcmIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.101 30c4.698 0 6.885-2.412 6.885-6.579 0-3.996-1.998-6.327-6.75-6.417a96.19 96.19 0 00-1.06-.01l-.592-.004-.576-.002-1.204-.002h-.069V30h3.366Zm.036-1.809H6.958v-9.396h1.233c2.808 0 4.5 1.26 4.5 4.635 0 3.492-1.88 4.761-4.554 4.761Zm14.41 1.989c3.41 0 4.832-2.133 5.13-4.5h-2.314c-.26 1.44-1.232 2.664-2.88 2.664-2.07 0-3.248-1.485-3.248-4.905 0-3.393 1.178-4.797 3.248-4.797 1.648 0 2.62 1.089 2.88 2.52h2.314c-.253-2.43-2.287-4.356-5.13-4.356-3.6 0-5.733 2.448-5.733 6.606 0 4.167 2.15 6.768 5.733 6.768Zm9.836-.18V19.857L35.785 30h1.828l3.428-10.206V30h2.224V16.986H40.15l-3.448 9.945-3.41-9.945H30.16V30h2.223Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.DcmIcon",
  "replaceColor": true
});